import { render, staticRenderFns } from "./authentication-success.vue?vue&type=template&id=320d4cd0&scoped=true&"
var script = {}
import style0 from "./authentication-success.vue?vue&type=style&index=0&id=320d4cd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320d4cd0",
  null
  
)

export default component.exports